'use client';

import { useModalAdapterOptional } from '@module/helpers/modal/adapter';
import useModalStore from '@module/stores/useModalStore';
import { useEffect } from 'react';

function BackNavigationModalDismissListener() {
  const clearModals = useModalStore((state) => state.clearModals);
  const modalAdapter = useModalAdapterOptional();

  useEffect(() => {
    const handlePopState = () => {
      clearModals();
      modalAdapter?.clear();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [clearModals, modalAdapter]);

  return null;
}

export default BackNavigationModalDismissListener;
